"use strict";
'use es6';

const BUSINESS_UNITS_DISPLAY_URL = '/business-units/v1/business-unit-displays/user/dropdown';
const DASHBOARD_URL = '/cos-domains/v1/domain-management/dashboard';
const EMAIL_DOMAINS_URL = '/email-mta-sending/v1/auth-domains';
const BRANDS_URL = '/domains-brands/v1/brands';
const URL_REDIRECTS_URL = '/url-mappings/v3/url-mappings';
const HUB_USERS_URL = '/users/v2/app/hub-users/';
const VIEW_ALL_BUSINESS_UNITS_VALUE = 'view-all';
(function () {
  function isUngated(authData, gate) {
    return authData.portal.enabled_gates.indexOf(gate) !== -1;
  }
  function isScoped(authData, gate) {
    return authData.user.scopes.indexOf(gate) !== -1;
  }
  function url(endpoint) {
    return window.quickFetch.getApiUrl(endpoint, true);
  }
  function getDefaultBusinessUnitId(businessUnits) {
    return businessUnits && businessUnits[0] && businessUnits[0].id;
  }
  function getBusinessUnitIdPathParam() {
    const searchMatches = window.location.pathname.match(`business-unit/(\\d+|${VIEW_ALL_BUSINESS_UNITS_VALUE})`);
    return searchMatches && searchMatches[1];
  }
  function fetchDomainsAndBrandsByBusinessUnit(businessUnitId) {
    window.quickFetch.makeEarlyRequest('domainsByBusinessUnit', {
      url: url(`${DASHBOARD_URL}/bu/${businessUnitId}?includeInternal=true`),
      timeout: 40000,
      dataType: 'json',
      contentType: 'application/json',
      type: 'GET'
    });
    window.quickFetch.makeEarlyRequest('brandDomainsByBusinessUnit', {
      url: url(`/domains-brands/v1/brands/bu/${businessUnitId}/limits-info`),
      timeout: 15000,
      dataType: 'json',
      contentType: 'application/json',
      extraHeaders: [{
        header: 'Accept',
        value: 'applciation/json'
      }],
      type: 'GET'
    });
  }
  function fetchDomainsAndBrands() {
    window.quickFetch.makeEarlyRequest('dashboard', {
      url: url(`${DASHBOARD_URL}?includeInternal=true`),
      timeout: 40000,
      dataType: 'json',
      contentType: 'application/json',
      type: 'GET'
    });
    window.quickFetch.makeEarlyRequest('brandDomains', {
      url: url(`${BRANDS_URL}/limits-info`),
      timeout: 15000,
      dataType: 'json',
      contentType: 'application/json',
      extraHeaders: [{
        header: 'Accept',
        value: 'applciation/json'
      }],
      type: 'GET'
    });
  }
  function fetchBusinessUnits(whenFinished) {
    window.quickFetch.makeEarlyRequest('businessUnits', {
      url: url(BUSINESS_UNITS_DISPLAY_URL),
      timeout: 40000,
      dataType: 'json',
      contentType: 'application/json',
      type: 'GET',
      whenFinished
    });
  }
  const subApp = window.location.pathname.substring(window.location.pathname.lastIndexOf('/') + 1);
  switch (subApp) {
    case 'url-redirects':
      {
        const defaultRedirectsFetchParams = [['offset', 0], ['excludeInternal', false], ['limit', 10], ['timeout', 7000]];
        window.quickFetch.makeEarlyRequest('redirects', {
          url: url(`${URL_REDIRECTS_URL}?${defaultRedirectsFetchParams.map(tuple => `${tuple[0]}=${tuple[1]}`).join('&')}`),
          timeout: 14000,
          dataType: 'json',
          contentType: 'application/json',
          type: 'GET'
        });
        window.quickFetch.makeEarlyRequest('redirectsCreators', {
          url: url(`${URL_REDIRECTS_URL}/users`),
          timeout: 14000,
          dataType: 'json',
          contentType: 'application/json',
          type: 'GET'
        });
        window.quickFetch.makeEarlyRequest('hubUsers', {
          url: url(HUB_USERS_URL),
          timeout: 14000,
          dataType: 'json',
          contentType: 'application/json',
          type: 'GET'
        });
        break;
      }
    default:
      {
        window.quickFetch.makeEarlyRequest('emailDomains', {
          url: url(EMAIL_DOMAINS_URL),
          timeout: 15000,
          dataType: 'json',
          contentType: 'application/json',
          type: 'GET'
        });
        const businessUnitId = getBusinessUnitIdPathParam();
        window.quickFetch.afterAuth(authData => {
          if (isUngated(authData, 'business-units:enforce-access-scope') && isScoped(authData, 'business-units-view-all-assets') && (!businessUnitId || businessUnitId === VIEW_ALL_BUSINESS_UNITS_VALUE)) {
            fetchBusinessUnits();
            fetchDomainsAndBrands();
          } else if (isUngated(authData, 'business-units:enforce-access-scope') && isScoped(authData, 'business-units-access') && businessUnitId !== VIEW_ALL_BUSINESS_UNITS_VALUE) {
            fetchBusinessUnits(businessUnits => {
              const initialBusinessUnitId = businessUnitId || getDefaultBusinessUnitId(businessUnits);
              if (initialBusinessUnitId) {
                fetchDomainsAndBrandsByBusinessUnit(initialBusinessUnitId);
              } else {
                fetchDomainsAndBrands();
              }
            });
          } else {
            fetchDomainsAndBrands();
          }
        });
        break;
      }
  }
})();

